import Vue from "vue";
import moment from "moment";
import VueRouter from "vue-router";
import Routes from "./routes";
import AccountService from "./services/accountService";
import UserService from "./services/userService";
import ErrorService from "./services/errorService";
import imgResource from "./Resource";
import loggerService from "./services/loggerService";
import Store from "./store";

const store = new Store();

Vue.config.productionTip = false;
Vue.prototype.$designResource = imgResource;

Vue.use(VueRouter);

const isCallback = AccountService.handleWindowCallback();
const router = new VueRouter({
  routes: Routes
});
const app = new Vue({
  router,
  created: function() {
    const _this = this;
    if (AccountService.isLogedin()) this.$router.push("main");
    else if (isCallback) {
      AccountService.login(() => {
        UserService.getMyAccount().then(user => {
          store.account = user.id;
          store.mail = user.email;
          _this.$router.push({ path: "/main" });
        });
      });
    } else this.$router.push("login");
  }
}).$mount("#app");

moment.locale("ja", {
  weekdays: [
    "日曜日",
    "月曜日",
    "火曜日",
    "水曜日",
    "木曜日",
    "金曜日",
    "土曜日"
  ],
  weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
});

var errorHandlingfunction = function(error) {
  try {
    const errorCode = ErrorService.randomNum();
    app.$router.push({
      path: `/error`,
      query: {
        errorCode
      }
    });
    loggerService.error(error, errorCode);
  } catch (e) {
    // 無限ループを避けるためにエラーを処理しない
  }
};

window.addEventListener("error", function(event) {
  errorHandlingfunction(event.error);
});
// promise で catch されていない場合
window.addEventListener("unhandledrejection", function(ex) {
  errorHandlingfunction(ex.reason);
});
// throw Errorをした場合、Vueでエラーが取られる
Vue.config.errorHandler = function(err) {
  errorHandlingfunction(err);
};
window.addEventListener("noAuthError", function() {
  loggerService.info("noAuthError");
  app.$router.push({
    path: `/login`,
    query: {
      sessionOut: true
    }
  });
});
